import { UsersApi } from "@/api/users";
import { UpdateFeatureFlagRequest } from "@/api/users/types";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useUpdateFeatureFlag = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: UpdateFeatureFlagRequest) =>
      UsersApi.updateFeatureFlag(body),
    onSuccess: (_, { name }) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.FEATURE_FLAG, name],
      });
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
  });

  return {
    updateFeatureFlag: mutate,
    isUpdateFeatureFlagLoading: isPending,
  };
};
